import { render, staticRenderFns } from "./UpdatePersonalInfo.vue?vue&type=template&id=59b9485a&scoped=true"
import script from "./UpdatePersonalInfo.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdatePersonalInfo.vue?vue&type=style&index=0&id=59b9485a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9485a",
  null
  
)

export default component.exports